import { SessionState } from "../session.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export const setLastAckReducer = (
  state: SessionState,
  action: PayloadAction<string | undefined>,
) => {
  state.lastAck = action.payload;
};
